const INITIAL_STATE = {
  data: {},
  errors: {},
}

const updateNotification = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'UPDATE_NOTIFICATION_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'UPDATE_NOTIFICATION_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default updateNotification;